import { GameContext } from '../../../contexts/GameContext';
import { useEventListener } from '../../../hooks/useEventListener';
import CodeInput from '../../common/CodeInput';
import React, { useContext, useState } from 'react';

type Props = {
    onConfirm: () => void;
    passCodeRegexp?: string;
    text?: string;
    isNumber: boolean;
};

export default function MCodeInput(props: Props) {
    const { onConfirm, passCodeRegexp, text, isNumber } = props;
    const [error, setError] = useState(false);
    const [commonMistake, setCommonMistake] = useState(false);
    const [commonMistakeMessage, setCommonMistakeMessage] = useState('');
    const [code, setCode] = useState('');

    const { stepContent } = useContext(GameContext);
    const { codeInputPassCodeCommonMistakeRegexp, codeInputPassCodeCommonMistakeMessage, additionalInfo } = stepContent;
    const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value);
        setError(false);
        setCommonMistake(false);
    };

    const confirm = () => {
        const codeForCheck = code.toLocaleLowerCase().trim().replace(/\s/g, '');
        if (code.length > 0) {
            if (passCodeRegexp) {
                const re = new RegExp(passCodeRegexp);
                if (re.test(codeForCheck)) {
                    onConfirm();
                } else if (
                    codeInputPassCodeCommonMistakeRegexp &&
                    codeInputPassCodeCommonMistakeMessage &&
                    codeInputPassCodeCommonMistakeRegexp.length > 0 &&
                    codeInputPassCodeCommonMistakeMessage.length > 0
                ) {
                    codeInputPassCodeCommonMistakeRegexp.forEach((element, index) => {
                        const commonMistakeRe = new RegExp(element);
                        if (commonMistakeRe.test(codeForCheck)) {
                            setCommonMistake(true);
                            setCommonMistakeMessage(codeInputPassCodeCommonMistakeMessage[index]);
                        } else {
                            setError(true);
                        }
                    });
                } else {
                    setError(true);
                }
            }
        }
    };

    function enterHandler({ key }: KeyboardEvent) {
        if ('Enter' === String(key)) {
            confirm();
        }
    }

    useEventListener('keydown', enterHandler);

    return (
        <div className="game-code-input">
            <CodeInput
                errorMessage="Kód je špatně"
                additionalMessage={additionalInfo}
                text={text}
                onClick={confirm}
                onChange={onCodeChange}
                code={code}
                error={error}
                commonMistake={commonMistake}
                commonMistakeMessage={commonMistakeMessage}
                isNumber={isNumber}
                maxLength={20}
            />
        </div>
    );
}
